<template>
  <div class="background_index_team">
    <div style="height: 92vh">
      <div style="padding-top: 30vh">
        <p style="font-size: 32px;margin-bottom: 0.5vh;">Our Team</p>
        <p>————</p>
        <p style="font-size: 24px;margin-bottom: 0">Comprehensive analysis and insights lie</p>
        <p style="font-size: 24px;">at the heart of our investment process.</p>
        <p style="font-size: 16px">Based on years of in-depth assessments of numerous companies in different
          industries,</p>
        <p style="font-size: 16px">we are willing to provide our portfolio companies with great assistance to
          accelerate post-investment performance.</p>
        <p style="font-size: 16px">SIG is dedicated to helping our entrepreneurs build successful companies by
          providing them with capital, guidance, network and the best resources available.</p>
        <div style="margin-top: 2vh">
          <a-button type="ghost">
            <router-link :to="'/team_en'"  @click.passive="backtotop">See More Team</router-link>
          </a-button>
        </div>
      </div>
    </div>
    <div class="index_down_button">
      <a-button type="ghost" shape="circle-outline" size="large" @click="next_page">
        <template v-slot:icon>
          <DownOutlined/>
        </template>
      </a-button>
    </div>
  </div>
</template>

<script>
import {DownOutlined} from "@ant-design/icons-vue/";

export default {
  name: 'Index_team',
  components: {
    DownOutlined,
  },
  setup() {
    const next_page = () => {   //跳转下一页
      document.documentElement.scrollBy({
        top: window.innerHeight,
        behavior: "smooth",
      })
    }
    const backtotop = () => {  //回到头部位置
      document.documentElement.scrollTo(0, 0)
    }
    return {next_page, backtotop}
  }
}

</script>
<style scoped>
.background_index_team {
  background-image: url("../../../assets/background/index_team.jpg");
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  margin: 0;
}
.background_index_team p{
  margin-bottom: 0.5em;
}

.index_down_button {
  height: 5vh;
  position: relative;
  bottom: 2vh;
}
</style>